@if (!orderReview?.approvedDate) {
  <tea-shop-fe-review-order
    [orderId]="orderId"
    [rating]="orderReview?.starRating"
    [comment]="orderReview?.reviewText"
    (reviewSubmitted)="onReviewSubmitted($event)"
  ></tea-shop-fe-review-order>
}

@if (orderReview?.approvedDate) {
  <div class="p-4 bg-white rounded-lg shadow">
    <div class="flex items-center mb-2">
      <div class="flex text-yellow-400">
        @for (star of [1,2,3,4,5]; track star) {
          <span class="text-lg">
            {{star <= orderReview!.starRating ? '★' : '☆'}}
          </span>
        }
      </div>
      <span class="ml-2 text-gray-600">{{orderReview!.starRating}}/5</span>
    </div>
    <p class="text-gray-700">{{orderReview!.reviewText}}</p>
    <p class="mt-2 text-sm text-gray-500">Published on: {{orderReview!.approvedDate | date}}</p>
  </div>
}
